module.exports = __webpack_public_path__ + "static/media/achievement-balling-shoes.889ee5cb.svg";